import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Card, CardImg } from "reactstrap";
import { withOrientationChange, isMobileSafari, isIE, isMobileOnly, isIPad13, isMobile } from 'react-device-detect';
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import screenfull from 'screenfull';

// Custom Component 
import EndAudioVideoCallConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import TotalBitRate from "../CommonComponents/BitRate/TotalBitRate";
import VideoComponent from "./Video";
import Spinner from "COMPONENTS/Spinner/Spinner";
import VideoMenu from "./VideoMenu";
import PreviewModal from "COMPONENTS/Video/Preview/Preview";
import IconsPositionBar from "./IconsPositionBar";
import { VirtualBackgroundFilter } from "COMPONENTS/CommonComponents/VirtualBackground/VirtualBackground";

import { audioVideoAction, sessionActions, headerAction } from "CONFIG/ActionFactory";

// Selectors
import {
  selectCurrentParticipantUniqueId,
  selectOrganiser
} from "../../Redux/Selector/SessionSelector";
import { selectSessionKey, selectUserToken } from "../MainLayout/selectors";
import { selectUserRole, selectParticipantId } from "../Whiteboard/selectors";
import {
  getAdmittedParticipants,
  selectSubModulesAudioVideo,
  selectDeactiveModules
} from "../CommonComponents/Header/selectors";
import {
  selectSnapshoteeId,
  selectSnapshotPermissionReply,
  selectShowSnapshot,
  getIsRecording,
  getAudioRecordingMessage,
  getVideoRecordingMessage,
  getRecordingTarget,
  getRecordingMethod,
  getIsVideoTransform,
  getPreviewAudio,
  getAudioDeviceId,
  getVideoDeviceId,
  getFacingMode,
  getIsVirtualBackground,
  getSelectedBackground,
  getShowAudioSettingModal,
  getIsFullScreenV2,
} from "REDUX/Selector/SessionSelector";
import { getStopVideoCallFlag, 
  getStartVideoCallFlag, 
  selectTurnServerData,
  getSortedParticipants,
  getVideoBandwidthSettings
} from  "./selectors";
import { getShowCustomerCoBrowse } from "COMPONENTS/CustomerCoBrowse/CustomerCoBrowseSelector"

// Constants
import { socketMessage, webRtcMessageId, mediaType, mediaStatus } from "WEBSOCKET/constants";
import {
  Modules, USER_ROLES,  COMPONENT_IN_FOCUS, TIMEOUT, RECORDING_TARGET, RECORDING_METHOD,
  FULL_SCREEN_V2_ID, MAX_Z_INDEX, FILTER_CONFIG,
} from "UTILS/Constants";
import { wsocket } from "WEBSOCKET/wsocket";
import { 
  getMediaConstraints,
  getUserMediaError,
  isMobileOriPad,
  isIphone13OrHigher,
  isLandscapeLayout,
  isAndroidPhone,
} from "UTILS/Utility";
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";

import FullScreenTargetComponent from "COMPONENTS/FullScreen/FullScreenTargetComponent"

// Strings
import { getMessage } from "CONFIG/i18n";

// Images";
import ic_audio_white from "ASSETS/Images/header_center/ic_audio_white.svg";
import ic_audio_gray from "ASSETS/Images/header_center/ic_audio_deactivate.svg";
import ic_video_white from "ASSETS/Images/header_center/ic_video_white.svg";
import ic_video_gray from "ASSETS/Images/header_center/ic_video_deactivate.svg";
import ic_swap from "ASSETS/Images/ic_swap.svg";
import ic_call_cut from "ASSETS/Images/video_menu/ic_call_cut_filled.svg";
import smoothscroll from 'smoothscroll-polyfill';
import {OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO } from "../../Utils/Constants";

export class AudioVideoContainer extends FullScreenTargetComponent {
  constructor(props) {
    super(props);
    this.state = {
      deviceList: {},
      showEndAudioCallConfirmationModal: false,
      showEndVideoCallConfirmationModal: false,
      webrtcSessionMedia:null,
      facingMode: this.props.facingMode,
      enableCamera: false,
      spinnerVisibility: false,
      isAudioVideo: false,
      currentRunningMedia: null,
      flimStripOverflow: false,
      isFilmstripVisible: true,
      hasUserClickedFilmStripCaret: false,
      isTransform: this.props.isVideoTransform,
      isFullScreen: false,
      showAudioSettingModal: false,
    };    
    this.currentStream = null;
    this.virtualBackgroundFilter = null;
    this.currentAudioStream = null;
    this.ondeviceChangeInterval = null;
    this.filmStripTimeout = null;
    this.fullScreenChangeHandler = this.fullScreenChangeHandler.bind(this);
    this.needRemoveFullScreenChangeHandler = false;
    this.renderInFullScreen = this.renderInFullScreen.bind(this);
    this.renderAnnotationInFullScreen = this.renderAnnotationInFullScreen.bind(this);
    this.peerErrorList = {};
    this.recoverCameraStream = this.recoverCameraStream.bind(this);
  }

  putPeerError = (uniqueId, media, error) => {
    if (this.peerErrorList[uniqueId] === undefined ) {
      this.peerErrorList[uniqueId] = {};
    }
    this.peerErrorList[uniqueId][media]=error;
  }
  isPeerError = (uniqueId, media) => {
    if (this.peerErrorList[uniqueId] && this.peerErrorList[uniqueId][media] ) {
      return true;
    }
    return false;
  }
  clearPeerError = (uniqueId, media) => {
    if (this.peerErrorList[uniqueId] && this.peerErrorList[uniqueId][media] ) {
      delete this.peerErrorList[uniqueId][media];
      if (Object.keys(this.peerErrorList[uniqueId]).length == 0 ) {
        delete this.peerErrorList[uniqueId];
      }
    }
  }

  componentDidMount() {
    smoothscroll.polyfill();
    /**
     * As soon as the Component loaded we'll assume to share own media
     */
    // get device list and set currentlySelectedDevice in the state
    this.getDeviceListAndDisplayStreamOnDeviceChange().then(() => {

      if(wsocket.audioAndVideoRtcPeer[this.props.uniqueId] &&
        wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["AUDIO"]) {

        // on swap audio video container mounts again but media is already 
        // so we just have to sort participants to display in the A/V tiles
        this.sortParticipantToAcronym();

        // on swapping with canvas, need to display media title and icon 
        if(this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO) {
          this.checkMediaTypeToDisplay();
          this.checkMediaTypeForSwitch();
        } else if(this.props.webRtcPermissionRequest === mediaType.AUDIO) {
          this.setState({
            webrtcSessionMedia: mediaType.AUDIO
          })
          this.props.headerAction.updateHeaderIconClass(
            this.props.webRtcPermissionRequest,
            "moduleIconActive cursorDisabled",
            " cursorDisabled"
          );
        }
      } else {
        if(this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO) {
          this.checkMediaTypeForSwitch();
        }
        this.sendShareMediaReqAndSortparticipants(false, true);  // this call is required to create endpoints
      }
    });

    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      return;
    } 
    
    // add onDeviceChange event for desktop so as to enumerate devices again 
    if(!isMobileOriPad()) {
      // this method is not supported on IE
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/ondevicechange
      navigator.mediaDevices.ondevicechange = (event) => {
        
        clearTimeout(this.ondeviceChangeInterval);
        this.ondeviceChangeInterval = setTimeout(() => {
          
          if(wsocket.audioAndVideoRtcPeer[this.props.uniqueId] &&
            wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["VIDEO"]) {
            if(this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO && 
              (this.props.webRtcPermissionReply || this.props.uniqueId === this.props.organiser)) {
              // get new device list and change stream if currently selected camera is removed
              this.getDeviceListAndDisplayStreamOnDeviceChange(true).then(() => {});
            }
          } else if(this.props.webRtcPermissionReply || this.props.uniqueId === this.props.organiser) {
            this.sendShareMediaReqAndSortparticipants(true, false);
          }
        }, 500);
      }
    }
    
    window.addEventListener("resize", () => {
      this.setFlimStripOverflow();
    });

    if(OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO == "true") {
      this.setupForEventsInAudioVideoContainer();
    }

    if(isIE) {
      this.setIconPosition();
      window.addEventListener("scroll", this.setIconPosition)
    }

    let updateMedia = "isTransform"
    audioVideoAction.setParticipantMediaStatus({
      uniqueId: this.props.uniqueId,
      [updateMedia]: this.state.isTransform,
    });

    setTimeout(() => {
      if (isLandscapeLayout(this.props.isLandscape)
        && !this.props.showCustomerCoBrowse
        && !(this.props.showSnapshot || (this.props.snapshoteeId && this.props.snapshotPermissionReply))
      ) {
        this.props.setComponentInFocus(COMPONENT_IN_FOCUS.AUDIO_VIDEO);
      }
    }, 500);

    if (!this.isFullScreenV2Target() && this.props.isFullScreenV2) {
      this.props.putFullScreenV2Target(this);
    }
  }
  
  setIconPosition = () => {
    // find bounds for self icon bar
    let annotationBar = document.getElementById("annotationBar");
    // let videoComponent = document.getElementById("videoComponent");

    let iconBar = document.getElementById("iconsPosition" + this.props.uniqueId);

    if(!iconBar) return;

    // when canvas is in focus set position of A/V icons based on annotation bar position 
    if(this.props.componentInFocus == COMPONENT_IN_FOCUS.CANVAS) {
      iconBar.style.position = "fixed"
    } else {
      iconBar.style.position = "static"
      iconBar.style.top = iconBar.style.top + "px"
    }

    if(!annotationBar) return;
    let annotationBarBound = annotationBar.getBoundingClientRect();
    iconBar.style.left = ((annotationBarBound.left+annotationBarBound.right)/2) + "px";
    iconBar.style.top = annotationBarBound.top + 10 + "px"
  }

  sendShareMediaReqAndSortparticipants = (sendShareMediaReq, sortParticipants) => {
    if (!wsocket.io) return;

    var video = document.getElementById("AudioVideoContainer");
    if (video) {
      video.style.display = "block";
    }

    navigator.mediaDevices.enumerateDevices().then(devices => {
      //get camera list
      let deviceList = devices.filter(device => {
        if (device.kind === "videoinput") {
          return device;
        }
      });

      this.setState({
        deviceList: deviceList
      },
      () => {
        // decide media type
        let media =
          this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO  // req is for audio_video
            ? ((this.state.deviceList && this.state.deviceList.length) || isMobileOriPad()) &&  // devicelist is non empty for desktop || user is on mobile
              (this.props.uniqueId === this.props.organiser || !this.props.snapshotPermissionReply) // agent || snapshot  is not runing for user (dont share VIDEO, share only AUDIO)
              ? mediaType.AUDIO_VIDEO
              : mediaType.AUDIO
            : mediaType.AUDIO;
        let recordingEnable = false;
        if (this.props.modules.includes(Modules.RECORDING)
          && (this.props.recordingMethod === RECORDING_METHOD.AUTO
          || this.props.isRecording)
        ) {
          recordingEnable = true;
        }
        var message = {
          data: {
            category: socketMessage.category.WEBRTC,
            action: webRtcMessageId.SHARE_WEBRTC_MEDIA,
            sessionKey: this.props.sessionKey,
            media: media,
            recordingEnable: recordingEnable,
            recordingTarget: this.props.recordingTarget,
          }
        };
        this.setState({
          webrtcSessionMedia: media,  // holds mediaType that was requested by agent
          currentRunningMedia: media  // mediatype that user is using because, although session mediatype = VIDEO, user can be using only AUDIO if he doesn't have a webcam 
        });

        // sort participants
        if (sortParticipants && this.props.admittedParticipants) {
          this.sortParticipantToAcronym();
        }
        // send SHARE_MEDIA req to create a media pipeline
        if(sendShareMediaReq)
          this.props.sendWebsocketMessage(
            socketMessage.events.MESSAGE,
            message
          );
      });
    }).catch(function (err) {
      console.error(err.name + ": " + err.message);
    });
    // highlight the header icon
    this.props.headerAction.updateHeaderIconClass(
      this.props.webRtcPermissionRequest,
      "moduleIconActive cursorDisabled",
      " cursorDisabled"
    );
    
  }

  checkMediaTypeToDisplay = () =>{
    _.map(this.props.admittedParticipants, participantObject => {
      if(participantObject.mediaType === mediaType.AUDIO_VIDEO){
        this.setState({webrtcSessionMedia: this.props.webRtcPermissionRequest})
      }
    })
  }

  checkMediaTypeForSwitch = () => {
    let isAudioVideo = false;
    _.filter(this.props.admittedParticipants, participantObject => {
      if(participantObject.uniqueId === this.props.uniqueId 
        && participantObject.mediaType === mediaType.AUDIO_VIDEO
        && (participantObject.videoStatus !== mediaStatus.MUTED || participantObject.videoStatus !== mediaStatus.MUTED_BY_AGENT)) {
        isAudioVideo = true
      }
    })
    this.setState({isAudioVideo: isAudioVideo})
  }

  fullScreenChangeHandler = () => {
    if(!screenfull.isFullscreen){
      if (isMobileOnly && this.props.isLandscape) {
        let parentDiv = document.getElementById("parent" + this.props.sortedParticipants[0].uniqueId);
        if (parentDiv) {
          parentDiv.style.height = "100%";
          parentDiv.style.width = "100%";
        }
      }
      this.setState({
        isFullScreen: false,
      });
      screenfull.off('change', this.fullScreenChangeHandler );
      this.needRemoveFullScreenChangeHandler = false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(!this.props.isFullScreenV2 ){
      if (this.state.isFullScreen && !prevState.isFullScreen && screenfull.isEnabled){
        screenfull.on('change', this.fullScreenChangeHandler );
        this.needRemoveFullScreenChangeHandler = true;
      }
    }
    if (!this.isFullScreenV2Target() && this.props.isFullScreenV2 && !prevProps.isFullScreenV2) {
      this.props.putFullScreenV2Target(this);
    }
    if(this.props.endCall !== prevProps.endCall && this.props.endCall) {
      this.props.webRtcPermissionRequest == mediaType.AUDIO_VIDEO
        ? this.onOpenCloseEndVideoCallConfirmationModal(true)
        : this.onOpenCloseEndAudioCallConfirmationModal(true);
      this.props.setEndCall(false);
    }
    if (this.props.admittedParticipants.length != prevProps.admittedParticipants.length) {
      setTimeout(() => {this.setFlimStripOverflow()},2000)
    }
    if(this.props.isLandscape !== prevProps.isLandscape && !isIE) {
      if(!isMobileSafari || isIphone13OrHigher() || isIPad13 ) {
        this.replaceTrack()
      } else if (this.props.webRtcPermissionReply && 
        this.props.webRtcPermissionRequest === "AUDIO_VIDEO") {
        // In case of iPhone we have to stop video call and start again.
        // as iPhone iOS12 (not for iOS13) stream freezes on orientation change
        /**
         * 1) we will stop call
         * 2) on change of 'stopVideoCall' flag we call STOP_USER_VIDEO (ws) which is done below in this method
         * 3) on _STOP_USER_VIDEO we set a flag 'startVideoCall' to start video call again 
         */
        audioVideoAction.setStopVideoCallFlag(true);
        this.setCurrentStream(null)
      }
    }

    // usecase: user switches camera on IE and sends STOP_USER_VIDEO websocket call
    // so when receives _STOP_USER_VIDEO from server, it disposes RTC pers and startVideoCall flag is set to true
    // however this startVideoCall props will be different only for that user who stops the stream  
    if(this.props.startVideoCall !== prevProps.startVideoCall && 
      this.props.startVideoCall && !this.props.snapshotPermissionReply 
      && this.props.webRtcPermissionRequest === "AUDIO_VIDEO" && 
      this.props.webRtcPermissionReply  
    ) {
      this.sendShareMediaReqAndSortparticipants(true, false);
      // reset start video call flag 
      audioVideoAction.setStartVideoCallFlag(false);
    }

    if (!_.isEqual(this.props.admittedParticipants, prevProps.admittedParticipants) 
      || !_.isEqual(this.props.sortParticipants, prevProps.sortParticipants)) {
      this.sortParticipantToAcronym();
    }

    // audio to video promotion for agent
    if(this.props.organiser === this.props.uniqueId 
      && this.props.webRtcPermissionRequest !== prevProps.webRtcPermissionRequest 
      && prevProps.webRtcPermissionRequest === "AUDIO"
      && this.props.webRtcPermissionRequest === "AUDIO_VIDEO") {
      this.sendShareMediaReqAndSortparticipants(true, false);  
      this.replaceAudioStream(this.props.previewAudio);
    }

    // if snapshot get Closed then start video of user(AUDIO To VIDEO promotion)
    if(this.props.snapshoteeId !== prevProps.snapshoteeId &&  // snapshoteeId is changed
      this.props.snapshoteeId === null &&   // snapshot is closed
      prevProps.snapshoteeId === this.props.uniqueId && // current user was doing snapshot
      this.props.webRtcPermissionReply && 
      this.props.webRtcPermissionRequest === "AUDIO_VIDEO") {
      this.props.headerAction.updateHeaderIconClass(
        mediaType.AUDIO,
        "moduleIcon cursorDisabled",
        " cursorDisabled"
      );
      this.sendShareMediaReqAndSortparticipants(true, false);  
    }

    // audio to video promotion for user
    if((this.props.webRtcPermissionRequest === "AUDIO_VIDEO" && 
    this.props.webRtcPermissionReply !== prevProps.webRtcPermissionReply && 
    this.props.webRtcPermissionReply && this.state.currentRunningMedia === "AUDIO")) {
      this.props.headerAction.updateHeaderIconClass(
        mediaType.AUDIO,
        "moduleIcon cursorDisabled",
        " cursorDisabled"
      );
      this.sendShareMediaReqAndSortparticipants(false, false); 
    }

    if (!_.isEqual(this.props.admittedParticipants, prevProps.admittedParticipants) // if any of users change media type
      ||  this.props.webRtcPermissionReply !== prevProps.webRtcPermissionReply
      && !this.props.webRtcPermissionReply) {
      
      if(this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO){
        this.checkMediaTypeToDisplay();
        this.checkMediaTypeForSwitch();
      }
    }

    if(this.props.recordingMethod === RECORDING_METHOD.MANUAL
      && this.props.isRecording !== prevProps.isRecording){
      this.sendRecrdingWebsocketMessage(this.props.isRecording);
    }

    //usecase: video call is running and snapshot request is accepted.  
    // we need to stopthe video call and start audio call
    if(this.props.stopVideoCall !== prevProps.stopVideoCall && this.props.stopVideoCall){
      if(this.props.snapshotPermissionReply){
        // stop tracks of current video call Stream if user accept snapshot request
        this.stopTracks(this.currentStream);
      }
      var message = {
        data: {
          category: socketMessage.category.WEBRTC,
          action: webRtcMessageId.STOP_USER_VIDEO,
          sessionKey: this.props.sessionKey,
          participantId: this.props.uniqueId
        }
      };
      this.props.sendWebsocketMessage(
        socketMessage.events.MESSAGE,
        message
      );
      audioVideoAction.setStopVideoCallFlag(false);
    }

    if (this.state.isTransform !== prevState.isTransform) {
      let updateMedia = "isTransform"
      audioVideoAction.setParticipantMediaStatus({
        uniqueId: this.props.uniqueId,
        [updateMedia]: this.state.isTransform,
      });
    }

    if (this.isFullScreenV2Target() && this.props.isFullScreenV2 ) {
      if (
        ( !_.isEqual(this.props.sortedParticipants, prevProps.sortedParticipants ) ) ||
        ( (!prevState.deviceList || !prevState.deviceList.length)
          && this.state.deviceList && this.state.deviceList.length >= 1)
      ) {
        this.doFullScreenRender();
      }
    }
  }
  sortParticipantToAcronym = () => {
    let participantList = _.cloneDeep(this.props.sortedParticipants);
    let firstParticipantRole = participantList[0]?.role;
    if(this.props.admittedParticipants) {
      // remove participants from sorted list which are not present in participant list
      _.map(participantList, (sortedParticipant, index) => {
        let participantIndex = this.props.admittedParticipants.findIndex(participant => {
          return participant && sortedParticipant && participant.uniqueId === sortedParticipant.uniqueId
        });
        if(participantIndex == -1) participantList.splice(index, 1)
      });

      // move the 1st participant to 0th index if agent is on 0th index 
      if(participantList.length >= 2 && 
        participantList.length < this.props.sortedParticipants.length &&
        firstParticipantRole !== USER_ROLES.AGENT &&
        this.props.organiser === this.props.uniqueId && 
        participantList[0].role === USER_ROLES.AGENT) {
        //copy 1st index particip[ant to 0th index and delete its copy from 2nd index
        participantList.splice(0, 0, participantList[1]); 
        participantList.splice(2,1); 
      }

      _.map(this.props.admittedParticipants, (participantObject, index) => {

        // check if participant is already present in the sorted list
        let participantIndex = -1;
        participantIndex = participantList.findIndex(participant => {
          return participant.uniqueId === participantObject.uniqueId
        });

        if(participantIndex == -1) {
          // add participant to sorted list only if he has accepted call
          if( participantObject.mediaType && participantObject.mediaType != "NONE" &&  
          !(typeof(participantObject.mediaType) === "object" && 
          !(participantObject.mediaType.audio || participantObject.mediaType.video))) {

            // for organiser:
            // 1st video -> of user who has accepted the request first
            // 2nd video -> self

            // for user:
            // 1st video -> of organiser
            // 2nd video -> self

            if(this.props.organiser === this.props.uniqueId) {
              if(participantObject.role !== USER_ROLES.AGENT && 
                (!participantList ||
                (participantList.length < 2))){
                participantList.splice(0, 0, participantObject);
              } else if (participantObject.role === USER_ROLES.AGENT) {
                participantList.splice(1, 0, participantObject);
              } else {
                participantList.push(participantObject);
              }
            } else {
              if (participantObject.role === USER_ROLES.AGENT) {
                participantList.splice(0, 0, participantObject);
              } else {
                if (participantObject.uniqueId === this.props.uniqueId) {
                  participantList.splice(1, 0, participantObject);
                } else {
                  participantList.push(participantObject);
                }
              }
            }
          }
        } else {
          // reassign object in case some values of object have changed (audio/video mute/unmute)
          participantList[participantIndex] = participantObject;
        }
      });
      audioVideoAction.setSortedParticipants(participantList);
    }
    else {
      audioVideoAction.setSortedParticipants([]);
    }
  }

  /*onMinimize = () => {
    document.getElementById("AudioVideoContainer").style.display = "none";
    this.props.headerAction.updateHeaderIconClass(
      this.props.webRtcPermissionRequest,
      "moduleIconActiveHidden",
      ""
    );
  };*/
  onClose = () => {
    this.stopTracks(this.currentStream);
    this.stopAudioTracks(this.currentAudioStream);
    //this.props.sessionActions.updateWebRtcPermissionReply(false);
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.STOP_ALL_WEBRTC_AUDIO_VIDEO,
        sessionKey: this.props.sessionKey,
        token: this.props.token
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    if(this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO){
      sessionActions.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    }
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture();
    }
  };

  getTotalWebrtcElement = () => {
    let count = 0;
    for (let i = 0; i < this.props.admittedParticipants.length; i++) {
      if (this.props.admittedParticipants[i].mediaType 
        && this.props.admittedParticipants[i].mediaType !== "NONE" 
        && !(typeof(this.props.admittedParticipants[i].mediaType) === "object" 
        && !(this.props.admittedParticipants[i].mediaType.audio 
          || this.props.admittedParticipants[i].mediaType.video))) {
        count++;
      }
            
    }
    return count;
  };

  onOpenCloseEndAudioCallConfirmationModal = (modalState) => {
    this.setState({
      showEndAudioCallConfirmationModal: modalState
    })
  }

  onOpenCloseEndVideoCallConfirmationModal = (modalState) => {
    this.setState({
      showEndVideoCallConfirmationModal: modalState
    })
  }

  setPrimaryParticipant = (index) => {
    // Swap index of clicked video box with 0th (primary) to show it in bigger size
    // As always the 0th index participant will be shown in bigger size
    let participantList = _.cloneDeep(this.props.sortedParticipants);
    if(participantList[0].uniqueId == this.props.uniqueId && index != 1) {    // self video is on big tile
      participantList.splice(0, 0, participantList[index]);  // put clicked user video at index 0 i.e. big tile
      participantList.splice(index + 1, 1);
    } else {    // self video is already at first position in filmstrip
      [participantList[0], participantList[index]] = [participantList[index], participantList[0]];
    }
    audioVideoAction.setSortedParticipants(participantList);
  }
  stopTracks = (localStream) => {
    this.virtualBackgroundFilter && this.virtualBackgroundFilter.stop();
    this.currentStream = null;
    if (localStream) {
      localStream.getTracks().forEach(track => track.stop());
      const videoTracks = localStream.getVideoTracks();
      for (let i = 0; i !== videoTracks.length; ++i) {
        videoTracks[i].stop();
      }
      let videoElement = document.getElementById(this.props.uniqueId + "video");
      if(videoElement){
        videoElement.srcObject = null;
      }
    }
  }
  stopAudioTracks = (localStream) => {
    this.currentAudioStream = null;
    if (localStream) {
      localStream.getTracks().forEach(track => track.stop());
      const audioTracks = localStream.getAudioTracks();
      for (let i = 0; i !== audioTracks.length; ++i) {
        audioTracks[i].stop();
      }
    }
  }

  recoverCameraStream = (newStream) => {
    const videoTrack = newStream.getVideoTracks()[0];
    const sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["VIDEO"].peerConnection.getSenders().find(function (s) {
      return s.track.kind == videoTrack.kind;
    });
    this.currentStream = newStream;
    sender.replaceTrack(videoTrack)
    .then(()=>{
      console.log(`Replace track successful`);
      const mediaElement = document.getElementById(this.props.uniqueId + "video");
      if ( mediaElement ) mediaElement.srcObject = newStream;
    }).catch((error)=>{
      console.error("Error while replaceTrack: ", error);
    });
  }

  replaceTrack = () => {
    let currentStream = this.currentStream;
    if(!wsocket.audioAndVideoRtcPeer[
    this.props.uniqueId
    ]) return;
    
    if(!wsocket.audioAndVideoRtcPeer[
    this.props.uniqueId
    ]["VIDEO"]) return;

    let localStream = wsocket.audioAndVideoRtcPeer[
    this.props.uniqueId
    ]["VIDEO"].getLocalStream();

    // stop tracks
    this.stopTracks(localStream);
    this.stopTracks(currentStream);

    let mediaElement = document.getElementById(this.props.uniqueId + "video");
    let constraints = getMediaConstraints({
      media: mediaType.VIDEO,
      videoBandwidthSettings: this.props.videoBandwidthSettings,
      isLandscape: this.props.isLandscape,
      audioDeviceId: this.props.audioDeviceId,
      videoDeviceId: this.props.videoDeviceId,
      facingMode: this.state.facingMode,
      isVirtualBackground: this.props.isVirtualBackground,
    });

    navigator.mediaDevices.getUserMedia(constraints).then(async(stream) => {
      this.currentStream = stream;
      let targetStream = stream;
      if (this.props.isVirtualBackground) {
        try {
          const filter = this.getCurrentVirtualBackgroundFilter();
          const filterStream = await filter.getFilteredStream(stream, (error) => {
            toastr.error(getMessage("VIRTUAL_BACKGROUND_FAILED"));
            this.hideSpinner();
            this.recoverCameraStream(stream);
          });
          this.currentStream = filterStream;
          targetStream = filterStream;
        } catch (error) {
          console.error(error);
          toastr.error(getMessage("VIRTUAL_BACKGROUND_FAILED"));
          this.hideSpinner();
        }
      }
      let videoTrack = targetStream.getVideoTracks()[0];
      let sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["VIDEO"].peerConnection.getSenders().find(function (s) {
        return s.track.kind == videoTrack.kind;
      });
      sender.replaceTrack(videoTrack).then(console.log("Replace track successful")).catch((error)=>{
        console.error("Error while replaceTrack: ", error);
      });
      mediaElement.srcObject = targetStream;
      if ( !this.props.isFullScreenV2 ) {
        mediaElement.play()
        .then(() =>
          console.log(`VIDEO has been played successfully`))
        .catch((error) => {
          console.log('error: ', error);
          console.log(`an error occurred while playing VIDEO, error : ${error && error.message ? error.message : JSON.stringify(error)}`)
        });
      } else {
        mediaElement.pause();
        console.log(`VIDEO has been paused successfully`);
        mediaElement = document.getElementById(this.props.uniqueId + "video" + FULL_SCREEN_V2_ID.SUFFIX );
        if ( mediaElement ) {
          console.debug(`replaceTrack() - navigator.mediaDevices.getUserMedia() set srcObject`);
          mediaElement.srcObject = targetStream;
          mediaElement.play()
          .then(() =>
            console.log(`VIDEO has been played successfully`))
          .catch((error) => {
            console.log('error: ', error);
            console.log(`an error occurred while playing VIDEO, error : ${error && error.message ? error.message : JSON.stringify(error)}`)
          });
        }
      }
    }).catch((error) => {
      console.error('[Video.js] getUserMedia error: ', error);
    });
  }

  isOverflowing = () => {
    let el = document.getElementById("flimStrip");
    let arrow = document.getElementById("arrowLeft")
    if(el) {
      return el.clientWidth != 0 && el.clientWidth < (el.scrollWidth - 5 - (arrow ? 2*arrow.clientWidth : 0))
    }
  }

  setFlimStripOverflow = () => {
    let overflow = this.isOverflowing();
    if(this.state.flimStripOverflow !== overflow) 
      this.setState({
        flimStripOverflow: overflow
      })
  }

  handleSwitches = (toggleFlag,variable) => {
    this.setState({isTransform: toggleFlag})
    headerAction.setVideoTransform(toggleFlag);

    let updateMedia = "isTransform"
    audioVideoAction.setParticipantMediaStatus({
      uniqueId: this.props.uniqueId,
      [updateMedia]: toggleFlag,
    });
  }

  switchCamera = () => {
    this.showSpinner();
    this.setState({enableCamera: false})
    if(isMobileOriPad()) {
      this.setState({
        facingMode: this.state.facingMode && this.state.facingMode == 'user' ? 'environment' : 'user'
      }, () => {
        this.setState({ isTransform: false });
        this.displayCameraStream();
      });
    } else {
      let currentIndex = this.state.deviceList.findIndex(device => device.deviceId == this.state.selectedDevice.deviceId);
      currentIndex = currentIndex == this.state.deviceList.length - 1 ? 0 : currentIndex + 1;
      this.props.headerAction.setVideoDevice(this.state.deviceList[currentIndex].deviceId);
      this.setState({
        selectedDevice: this.state.deviceList[currentIndex]
      }, () => {
        if(isIE) {
          // handling for IE because replcaeTrack is not supported on IE we have to dispose the RTCPeer and recreate
          audioVideoAction.setStopVideoCallFlag(true);
          // setTimeout(() => this.hideSpinner(),2000);
          this.currentStream = null;
        } else {
          setTimeout(() => {
            this.displayCameraStream();            
          }, 200);
        }
      });
    }
  }

  setCurrentStream = (stream) => {
    this.currentStream = stream;
  }
  setCurrentAudioStream = (stream) => {
    this.currentAudioStream = stream;
  }
  setCurrentVirtualBackgroundFilter = (filter) => {
    this.virtualBackgroundFilter = filter;
  }
  getCurrentVirtualBackgroundFilter = () => {
    if ( !this.virtualBackgroundFilter ) {
      const filter = new VirtualBackgroundFilter(FILTER_CONFIG[this.props.selectedBackground]);
      this.virtualBackgroundFilter = filter;
    } else {
      this.virtualBackgroundFilter.setBackground(FILTER_CONFIG[this.props.selectedBackground]);
    }
    return this.virtualBackgroundFilter;
  }
  getDeviceListAndDisplayStreamOnDeviceChange = (onDeviceChange = false) => {
    // onDeviceChange is for to check function gets call after device change
    return new Promise((resolve, reject) => {
      if(!isMobileOriPad()) {
        navigator.mediaDevices.enumerateDevices().then(devices => {
          console.log('[getDeviceListAndDisplayStreamOnDeviceChange] devices list: ', devices);
          this.showSpinner();
          let selectedDevice = this.state.selectedDevice;
          
          //get camera list
          let deviceList = devices.filter(device => device.kind === "videoinput");
          this.setState({
            deviceList: deviceList
          }, () => {
            console.log("Got deviceList in getDeviceListAndDisplayStreamOnDeviceChange");
            resolve("success");
          });

          let currentDeviceId = selectedDevice && selectedDevice.deviceId;
          
          let isCurrentlyStreamingDeviceInNewDeviceList = devices.filter(device => 
            device.deviceId === currentDeviceId).length > 0;

          // onDeviceChange, if same device is being used for streaming, just hide spinner and return
          if(onDeviceChange && isCurrentlyStreamingDeviceInNewDeviceList) {
            this.hideSpinner();
            return;
          } 
          // this evaluates to be undefined when there was only one camera 
          // and it is disconnected
          let deviceToBeSelected = deviceList[0];
          if (this.props.videoDeviceId) {
            let currentIndex = deviceList.findIndex(device => device.deviceId == this.props.videoDeviceId);
            deviceToBeSelected = deviceList[currentIndex];
          } else {
            this.props.headerAction.setVideoDevice(deviceToBeSelected.deviceId);
          }
          if(deviceToBeSelected && currentDeviceId !== deviceToBeSelected.deviceId) {
            // control will come here for first time and when there is change in device list
            // i. for first time, we don't need to call displayCameraStream because stream is created by rtcPeerConnection 
            // ii. when change in device list, we need to switch stream to available device 
            this.hideSpinner();
            this.setState({
              selectedDevice: deviceToBeSelected,
            }, () => {
              if(onDeviceChange) {
                // displayCameraStream should be called only if currently selected camera get removed
                this.displayCameraStream();
              }
            });
          } else {
            // When there is only one webcam connected and we reconnect that webcam 
            // selectedDevice value is not set to null 
            // due to which stream does not start again 
            // Reason: deviceToBeSelected is undefined
            if(!deviceToBeSelected && onDeviceChange) {
              this.setState({
                selectedDevice: null
              })
            }
            this.hideSpinner();
          }
        });
      } else {
        resolve("success");
      }
    });
  }

  displayCameraStream = () => {
    // if (this.state.selectedDevice !== null || this.state.facingMode !== null) {
    let videoConstraints = getMediaConstraints({
      media: mediaType.VIDEO,
      videoBandwidthSettings: this.props.videoBandwidthSettings,
      isLandscape: this.props.isLandscape,
      audioDeviceId: this.props.audioDeviceId,
      videoDeviceId: this.props.videoDeviceId,
      facingMode: this.state.facingMode,
      isVirtualBackground: this.props.isVirtualBackground,
    });

    let mediaElement = document.getElementById(this.props.uniqueId + "video")
    // displayMediaStream is called in 3 scenarios -
    // a. Orientation change
    // b. Switch Camera
    // c. Change webcam
    this.stopTracks(this.currentStream);
    navigator.mediaDevices.getUserMedia(videoConstraints)
    .then(async(stream) => {
      this.currentStream = stream;
      let targetStream = stream;
      if (this.props.isVirtualBackground) {
        try {
          const filter = this.getCurrentVirtualBackgroundFilter();
          const filterStream = await filter.getFilteredStream(stream, (error) => {
            toastr.error(getMessage("VIRTUAL_BACKGROUND_FAILED"));
            this.hideSpinner();
            this.recoverCameraStream(stream);
          });
          this.currentStream = filterStream;
          targetStream = filterStream;
        } catch (error) {
          console.error(error);
          toastr.error(getMessage("VIRTUAL_BACKGROUND_FAILED"));
          this.hideSpinner();
        }
      }
      let videoTrack = targetStream.getVideoTracks()[0];
      let sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["VIDEO"].peerConnection.getSenders().find(function (s) {
        return s.track.kind == videoTrack.kind;
      });
      sender.replaceTrack(videoTrack)
      .then(console.log("Replace track successful"))
      .catch((error)=>{
        console.error("Error while replaceTrack: ", error);
      });

      mediaElement.srcObject = targetStream;

      mediaElement.play()
      .then(() =>
        console.log(`VIDEO has been played successfully`))
      .catch((error) => {
        console.log('error: ', error);
        console.log(`an error occurred while playing VIDEO, error : ${error && error.message ? error.message : JSON.stringify(error)}`)
      });
    })
    .catch((error) => {
      let errorMessage = getUserMediaError(error, mediaType.VIDEO);
      if(errorMessage) {
        toastr.error(getMessage(errorMessage));
        this.hideSpinner();
        return;
      } else {
        if(!isMobileOriPad() && this.deviceList && this.deviceList.length > 1) {
          this.switchCamera();
        }
        else {
          this.hideSpinner();
        }
      }          
    });
    // }
  }

  replaceAudioStream = (isUnmute) => {
    const constraints = getMediaConstraints({
      media: mediaType.AUDIO,
      audioDeviceId: this.props.audioDeviceId,
    });
    this.stopAudioTracks(this.currentAudioStream)
    navigator.mediaDevices.getUserMedia(constraints)
    .then(stream => {
      this.currentAudioStream = stream;
      let audioTrack = stream.getAudioTracks()[0];
      audioTrack.enabled = isUnmute ? true: false;
      let sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["AUDIO"].peerConnection.getSenders().find(function (s) {
        return s.track.kind == audioTrack.kind;
      });
      sender.replaceTrack(audioTrack)
      .then(console.log("Replace audio track successful"))
      .catch((error)=>{
        console.error("Error while audio replaceTrack: ", error);
      });
    })
    .catch((error) => {
      let errorMessage = getUserMediaError(error, mediaType.AUDIO);
      if(errorMessage) {
        toastr.error(getMessage(errorMessage));
      }          
      this.hideSpinner();
    });
  }

  showSpinner = () => {
    this.setState({
      spinnerVisibility: true
    })
  }

  hideSpinner = () => {
    this.setState({
      spinnerVisibility: false
    })
  }

  setEnableCameraFlag = (value) =>{
    this.setState({
      enableCamera: value
    })
  }

  //To setup Events  when mouse enters in AudioVideoContainer
  setupForEventsInAudioVideoContainer = () => {
    if(!this.state.hasUserClickedFilmStripCaret) {
      var videoComponent = document.getElementById("videoComponent");
      videoComponent.addEventListener("mousemove", this.resetFilmStripTimer, false);
      // videoComponent.addEventListener("mousedown", this.resetFilmStripTimer, false);
      // videoComponent.addEventListener("keypress", this.resetFilmStripTimer, false);
      // videoComponent.addEventListener("DOMMouseScroll", this.resetFilmStripTimer, false);
      // videoComponent.addEventListener("mousewheel", this.resetFilmStripTimer, false);
      // videoComponent.addEventListener("touchmove", this.resetFilmStripTimer, false);
      // videoComponent.addEventListener("MSPointerMove", this.resetFilmStripTimer, false);
      //this.startTimerToHideFilmStrip();
    }
  }

  //Function starts The timer if there is any event
  startTimerToHideFilmStrip = () => {
    // wait 5 seconds before collapse Filmstrip
    this.filmStripTimeout = setTimeout(() => {
      this.setState({
        isFilmstripVisible: false
      });
    }, TIMEOUT.AUDIO_VIDEO_FILM_STRIP_TIMEOUT);
  }

  //Function reset timer if there is any event 
  resetFilmStripTimer = (e) => {
    if(!this.state.isFilmstripVisible) {
      clearTimeout(this.filmStripTimeout);
      this.setState({
        isFilmstripVisible: true
      });         
      this.startTimerToHideFilmStrip();
    }
  }

  setUserHasClickedFilmStripCaret = () => {
    console.log("in setUserHasClickedFilmStripCaret");
    clearTimeout(this.filmStripTimeout);
    this.setState({
      hasUserClickedFilmStripCaret: true
    });
    //var videoComponent = document.getElementById("videoComponent");
    //videoComponent.removeEventListener("mouseenter", this.resetFilmStripTimer);
    // videoComponent.removeEventListener("mousedown", this.resetFilmStripTimer);
    // videoComponent.removeEventListener("keypress", this.resetFilmStripTimer);
    // videoComponent.removeEventListener("DOMMouseScroll", this.resetFilmStripTimer);
    // videoComponent.removeEventListener("mousewheel", this.resetFilmStripTimer);
    // videoComponent.removeEventListener("touchmove", this.resetFilmStripTimer);
    // videoComponent.removeEventListener("MSPointerMove", this.resetFilmStripTimer);
  }

  shouldShowSwapIcon = () => {
    return (!(this.props.showSnapshot || (this.props.snapshoteeId
      && this.props.snapshotPermissionReply))
      && this.props.componentInFocus !== COMPONENT_IN_FOCUS.AUDIO_VIDEO
      && !this.props.showCustomerCoBrowse
      && isLandscapeLayout(this.props.isLandscape)
    )
  }

  callPictureInPicture = () => {
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture();
    } else {
      if (document.pictureInPictureEnabled) {
        let videoContainer = document.getElementById("videoContainer" + true);
        let video = videoContainer.querySelector('video');
        video.requestPictureInPicture()
        .then(() => {
          this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
        })
        .catch((error) => {
          console.error("Error during call Picture in Picture: ", error.message);
        });
      }
    }
  }

  toggleScreenZoomout = () => {
    if (isMobileOnly && this.props.isLandscape) {
      let parentDiv = document.getElementById("parent" + this.props.sortedParticipants[0].uniqueId);
      parentDiv.style.height = "100%";
      parentDiv.style.width = "100%";
    }

    this.setState({
      isFullScreen : false,
    })
    screenfull.exit();
  }
  
  toggleScreenZoomin = async () => {
    if ( this.props.horizontalDisplayFixed && isAndroidPhone() ) {
      if( await this.props.handleFullScreenV2(this) ) {
        return;
      }
    }
    let fullScreenDiv = document.getElementById("videoContainer" + true);

    if (isMobileOnly && this.props.isLandscape) {
      let parentDiv = document.getElementById("parent" + this.props.sortedParticipants[0].uniqueId);
      parentDiv.style.height = "100vh";
      parentDiv.style.width = "100vw";
    }

    let imageSrc = document.getElementById("minimize");
    if(imageSrc !== null){
      imageSrc.style.display = "inline";
    }
    screenfull.request(fullScreenDiv, {navigationUI: 'hide'});
    this.setState({
      isFullScreen: true,
    });
  }

  renderRecordingMessage = () => {
    let message;
    if (this.props.isRecording) {
      if(this.state.webrtcSessionMedia === mediaType.AUDIO) {
        message = this.props.audioRecordingMessage
      } else if (this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO) {
        message = this.props.recordingTarget && this.props.recordingTarget.length === 1 
          && this.props.recordingTarget[0] === RECORDING_TARGET.AUDIO
          ? this.props.audioRecordingMessage
          : this.props.videoRecordingMessage
      }
    }
    if (!message) return;
    return(
      <label className="recordingMassage">
        {message}
      </label>
    )
  }

  sendRecrdingWebsocketMessage = (isStart) => {
    const media = (this.props.uniqueId === this.props.organiser || !this.props.snapshotPermissionReply)
      ? this.props.webRtcPermissionRequest  // agent || snapshot  is not runing for user (dont share VIDEO, share only AUDIO)
      : mediaType.AUDIO;

    let action = "";
    if (isStart) {
      action = webRtcMessageId.START_RECORDING;
    } else {
      action = webRtcMessageId.STOP_RECORDING;
    }
    const message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: action,
        sessionKey: this.props.sessionKey,
        media: media,
        recordingTarget: this.props.recordingTarget,
      }
    };
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      message
    );
  }

  handleVideoSettingModalShow = () => {
    if (isMobileSafari) {
      this.stopTracks(this.currentStream);
    }
    audioVideoAction.setAudioSettingModal(true);
  }

  renderPreviewModal() {
    let currentAudioStatus = null;
    let currentVideoStatus = null;
    if (this.props.sortedParticipants.length > 0) {
      const myParticipant = this.props.sortedParticipants.find(participant => participant.uniqueId == this.props.uniqueId);
      currentAudioStatus = myParticipant.audioStatus;
      currentVideoStatus = myParticipant.videoStatus;
    }

    return <PreviewModal
      show={this.props.showAudioSettingModal}
      handlePreviewModalCancelClick={this.handlePreviewModalCancelClick}
      handlePreviewModalStartClick={this.handlePreviewModalStartClick}
      isStart={false}
      currentAudioStatus={currentAudioStatus}
      currentVideoStatus={currentVideoStatus}
      currentReverse={this.props.isVideoTransform}
      currentAudioDeviceId={this.props.audioDeviceId}
      currentVideoDeviceId={this.props.videoDeviceId}
      currentFacingMode={this.props.facingMode}
      currentVirtualBackground={this.props.isVirtualBackground}
      currentSelectedBackground={this.props.selectedBackground}
    />;
  }

  handlePreviewModalCancelClick = () => {
    audioVideoAction.setAudioSettingModal(false);
  }

  handlePreviewModalStartClick = (
    previewAudio, previewVideo, previewReverse, audioDeviceId, videoDeviceId, facingMode,
    previewVirtualBackground, selectedBackground,
  ) => {
    audioVideoAction.setAudioSettingModal(false);
    const audioStatus = previewAudio ? mediaStatus.UNMUTED : mediaStatus.MUTED;
    const videoStatus = previewVideo ? mediaStatus.UNMUTED : mediaStatus.MUTED;
    let currentAudioStatus = null;
    let currentVideoStatus = null;
    if (this.props.sortedParticipants.length > 0) {
      const myParticipant = this.props.sortedParticipants.find(participant => participant.uniqueId == this.props.uniqueId);
      currentAudioStatus = myParticipant.audioStatus;
      currentVideoStatus = myParticipant.videoStatus;
    }
    if (currentAudioStatus !== audioStatus) {
      this.setMute(previewAudio, mediaType.AUDIO);
    }
    if (currentVideoStatus !== videoStatus){
      this.setMute(previewVideo, mediaType.AUDIO_VIDEO);
    }
    this.setState({isTransform: previewReverse});
    headerAction.setVideoTransform(previewReverse);
    if(isMobileOriPad()) {
      headerAction.setFacingMode(facingMode);
      this.setState({facingMode});
    } else {
      headerAction.setMediaDevice(audioDeviceId, videoDeviceId);
    }
    headerAction.setVirtualBackground(previewVirtualBackground, selectedBackground);

    setTimeout(() => {
      this.replaceAudioStream(previewAudio);
      this.displayCameraStream();      
    }, 200);
  }

  setMute(isUnmute, currentMediaType) {
    const muteStatus = isUnmute ? mediaStatus.UNMUTED : mediaStatus.MUTED;
    let webRtcPeerValue = "VIDEO";
    let senderTrackKind = "video";
    let updateMedia = "videoStatus"
    if (currentMediaType == mediaType.AUDIO) {
      webRtcPeerValue = "AUDIO";
      senderTrackKind = "audio";
      updateMedia = "audioStatus"
    }
    if(!isIE) {
      let sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId][webRtcPeerValue].peerConnection.getSenders().find(function (s) {
        return s.track.kind == senderTrackKind;
      });
      if(sender && sender.track) {
        sender.track.enabled = !isUnmute;
      }
    }
    audioVideoAction.setParticipantMediaStatus({
      uniqueId: this.props.uniqueId,
      [updateMedia]: muteStatus,
    });
    audioVideoAction.toggleMedia(
      this.props.sessionKey,
      currentMediaType,
      muteStatus,
      this.props.uniqueId
    )
  }

  getMaxZIndex = () => {
    return MAX_Z_INDEX.AUDIO_VIDEO;
  }

  renderInFullScreen = (isMain) => {
    const isVideo =
      this.props.webRtcPermissionRequest == mediaType.AUDIO_VIDEO
        ? true
        : false;
    const primaryParticipant = this.props.sortedParticipants[0];
    return (
      <div className="AudioVideo"
        id={"AudioVideo" + FULL_SCREEN_V2_ID.SUFFIX}
      >
        {primaryParticipant && primaryParticipant.mediaType !== "NONE" &&  
          !(typeof(primaryParticipant.mediaType) === "object" && 
          !(primaryParticipant.mediaType.audio || primaryParticipant.mediaType.video)) &&
          <VideoComponent
            index={0}
            sendWebsocketMessage={this.props.sendWebsocketMessage}
            uniqueId={this.props.uniqueId}
            participant={primaryParticipant}
            participants={this.props.sortedParticipants}
            sessionKey={this.props.sessionKey}
            key={primaryParticipant.uniqueId + "video"}
            totalWebRtcElement={this.getTotalWebrtcElement()}
            deviceList={this.state.deviceList}
            webRtcPermissionRequest={
              this.props.webRtcPermissionRequest
            }
            isTransform={this.state.isTransform}
            isVideo={isVideo}
            snapshoteeId={this.props.snapshoteeId}
            organiser={this.props.organiser}
            onOpenCloseEndVideoCallConfirmationModal={this.onOpenCloseEndVideoCallConfirmationModal}
            onOpenCloseEndAudioCallConfirmationModal={this.onOpenCloseEndAudioCallConfirmationModal}
            isLandscape={this.props.isLandscape}
            currentStream={this.currentStream}
            snapshotPermissionReply={this.props.snapshotPermissionReply}
            turnServer={this.props.turnServer}
            showSpinner={this.showSpinner}
            hideSpinner={this.hideSpinner}
            enableCamera={this.setEnableCameraFlag}
            facingMode={this.state.facingMode}
            selectedDevice={this.state.selectedDevice}
            setCurrentStream={this.setCurrentStream}
            setCurrentAudioStream={this.setCurrentAudioStream}
            headerAction={this.props.headerAction}
            setFlimStripOverflow={this.setFlimStripOverflow}
            componentInFocus={this.props.componentInFocus}
            setScreenShareTopMargin={this.props.setScreenShareTopMargin}
            videoBandwidthSettings={this.props.videoBandwidthSettings}
            audioVideoAction={audioVideoAction}
            isMainScreen={true}
            isFullScreen={false}
            toggleScreenZoomout={this.toggleScreenZoomout}
            audioDeviceId={this.props.audioDeviceId}
            videoDeviceId={this.props.videoDeviceId}
            isFlimStripContainer={false}
            language={this.props.language}
            isFullScreenV2={this.props.isFullScreenV2}
            inFullScreenV2Container={true}
            inFullScreenV2Main={isMain}
            isPeerError={this.isPeerError}
          />
        }
        {this.props.sortedParticipants.length > 1 &&
          <React.Fragment>
            <div 
              className={
                !isMain
                  ? "flimStripContainer overlappingFilmStrip alignItemsCenter justifyContentFlexCenter show positionAbsolute"
                  : "flimStripContainer overlappingFilmStrip alignItemsCenter justifyContentFlexCenter show scrollableFilmStrip"
              }
              id={"flimStripContainer" + FULL_SCREEN_V2_ID.SUFFIX}
              role="tabpanel"
              aria-labelledby="headingOne"
            >
              {<div 
                className={ isMain ? "flimStrip show" : "flimStrip"}
                id={"filmStrip" + FULL_SCREEN_V2_ID.SUFFIX}
                style ={{"flexDirection":"column-reverse"}}  
              >
                {this.props.sortedParticipants.map((participant,index) => {
                  {
                    return participant.uniqueId !== primaryParticipant.uniqueId &&    // primary participant is already displayed
                  (participant.mediaType == mediaType.AUDIO || participant.mediaType == mediaType.AUDIO_VIDEO) ? (
                        <VideoComponent
                          index={index}
                          sendWebsocketMessage={this.props.sendWebsocketMessage}
                          setPrimaryParticipant={this.setPrimaryParticipant}
                          primaryParticipant={primaryParticipant}
                          uniqueId={this.props.uniqueId}
                          participant={participant}
                          participants={this.props.sortedParticipants}
                          sessionKey={this.props.sessionKey}
                          key={participant.uniqueId + "video"}
                          totalWebRtcElement={this.props.sortedParticipants.length}
                          deviceList={this.state.deviceList}
                          webRtcPermissionRequest={
                            this.props.webRtcPermissionRequest
                          }
                          isVideo={isVideo}
                          isTransform={this.state.isTransform}
                          snapshoteeId={this.props.snapshoteeId}
                          organiser={this.props.organiser}
                          onOpenCloseEndVideoCallConfirmationModal={this.onOpenCloseEndVideoCallConfirmationModal}
                          onOpenCloseEndAudioCallConfirmationModal={this.onOpenCloseEndAudioCallConfirmationModal}
                          isLandscape={this.props.isLandscape}
                          currentStream={this.currentStream}
                          snapshotPermissionReply={this.props.snapshotPermissionReply}
                          turnServer={this.props.turnServer}
                          showSpinner={this.showSpinner}
                          hideSpinner={this.hideSpinner}
                          enableCamera={this.setEnableCameraFlag}
                          facingMode={this.state.facingMode}
                          selectedDevice={this.state.selectedDevice}
                          setCurrentStream={this.setCurrentStream}
                          setCurrentAudioStream={this.setCurrentAudioStream}
                          headerAction={this.props.headerAction}
                          setFlimStripOverflow={this.setFlimStripOverflow}
                          isFilmstripVisible={this.state.isFilmstripVisible}
                          componentInFocus={this.props.componentInFocus}
                          setScreenShareTopMargin={this.props.setScreenShareTopMargin}
                          videoBandwidthSettings= {this.props.videoBandwidthSettings}
                          audioVideoAction= {audioVideoAction}
                          isMainScreen={false}
                          isFullScreen={false}
                          toggleScreenZoomout={this.toggleScreenZoomout}
                          audioDeviceId={this.props.audioDeviceId}
                          videoDeviceId={this.props.videoDeviceId}
                          // showFilmStrip={this.showFilmStrip}
                          isFlimStripContainer={true}
                          language={this.props.language}
                          isFullScreenV2={this.props.isFullScreenV2}
                          inFullScreenV2Container={true}
                          inFullScreenV2Main={isMain}
                          isPeerError={this.isPeerError}
                        />
                      ) : null;
                  }
                })}
              </div>}
            </div>
          </React.Fragment> }
        { this.props.sortedParticipants
          && isMain
          && this.props.sortedParticipants.length > 1 &&
          <div
            id={"filmStripHandler" + FULL_SCREEN_V2_ID.SUFFIX}
            className={"filmStripCaret"}
          >
            <div className="caretStyle">
              <div
                data-toggle="collapse"
                href={"#filmStrip" + FULL_SCREEN_V2_ID.SUFFIX}
                aria-expanded="true"
                aria-controls={"filmStrip" + FULL_SCREEN_V2_ID.SUFFIX}
              />
            </div>
          </div>
        }
        {
          this.renderAnnotationInFullScreen(isMain)
        }
      </div>
    );
  }

  renderAnnotationInFullScreen = (isMain) => {
    if(this.props.admittedParticipants && this.props.admittedParticipants.length > 0) {
      const participant = this.props.admittedParticipants.find(function(participantObject){
        return participantObject.uniqueId === this.props.uniqueId;
      }, this);
      if (participant) {
        return (
          <IconsPositionBar
            sessionKey={this.props.sessionKey}
            organiser={this.props.organiser}
            uniqueId={this.props.uniqueId}
            participant={participant}
            index={this.props.admittedParticipants.length}
            selfIcons={false}
            isVideo={true}
            hideButton={false}
            parentClassname="annotationArea"
            iconsDivClassname="iconsBackground"
          />
        );
      }
    }
    return null;
  }
  render() {
    // remove collapse class of filmstrip if canvas is in focus 
    if(this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS
      && document.getElementById("filmStrip")) {
      document.getElementById("filmStrip").classList.remove("collapse");
    }
    let smallVideoLimit = this.props.isLandscape ? 4 : 3;
    let isVideo =
    this.props.webRtcPermissionRequest == mediaType.AUDIO_VIDEO
      ? true
      : false;

    // the first participant in the list will always be primary (shown in bigger size)
    let primaryParticipant = this.props.sortedParticipants[0];

    // for smooth effect 
    let fullScreenAudioVideoContainer = this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO 
      ? {minHeight: "calc(75vw * 0.56 + 2em)"} 
      // A/V container will be rendered in div with width 75% calculated height to maintain 16:9 ratio
      // 2em is added for audio video header
      : {};
    //video windos position change
    let smallVideoPostionRightShow = (this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO)? true : false; 
    return (
      <React.Fragment>
        {this.state.spinnerVisibility && <Spinner showSpinner={this.state.spinnerVisibility} />}
        <div id ="videoComponent" className="videoComponent">
          { this.renderPreviewModal() }
          <Card 
            className = {
              OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO != "true"  && this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO
                ? "cardBodyNonOverlapping cardBody videoComponent p-0"
                : "cardBody videoComponent p-0"
            }
            style={fullScreenAudioVideoContainer}
          >
            {
              // title bar - media type icon
            }
            <div className={window._env_.REACT_APP_SHOW_BITRATE == "true" && !isIE
              ? "audioVideoHeader"
              : "audioVideoHeader paddingWithoutBitrate"
            }>
              {
                // header contents on left 
              }
              <div className="leftHeader">
                <CardImg
                  src={
                    OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO != "true" && this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO
                      ? this.state.webrtcSessionMedia === mediaType.AUDIO_VIDEO
                        ? ic_video_gray
                        : ic_audio_gray
                      : this.state.webrtcSessionMedia === mediaType.AUDIO_VIDEO
                        ? ic_video_white
                        : ic_audio_white
                  }
                  className="iconAudio"
                />
                <label className={
                  OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO != "true" && this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO 
                    ? "title darkGrayTitle"
                    : "title whiteTitle"
                }>
                  {
                    // title bar - media type title
                    this.state.webrtcSessionMedia === mediaType.AUDIO
                      ? getMessage("AUDIO")
                      : this.state.webrtcSessionMedia === mediaType.AUDIO_VIDEO
                        ? getMessage("AUDIO_VIDEO")
                        : ""
                  }
                </label>
                {this.renderRecordingMessage()}
              </div>
              {
                // header contents on right
              }
              <div className="rightHeader">
                {
                  // bit rate
                  window._env_.REACT_APP_SHOW_BITRATE == "true" &&
                  !isIE &&
                  <TotalBitRate 
                    uniqueId={this.props.uniqueId}
                    parentContainer = {document.getElementById("videoComponent")}
                    sentLabel={getMessage("SENT")}
                    recvLabel={getMessage("RECV")}
                    labelClassname={OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO != "true"  
                    && this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO 
                      ? "darkGrayTitle" 
                      : "whiteTitle"}
                  />
                }
                {
                  // canvas - video swap
                  this.shouldShowSwapIcon()
                  && <CardImg
                    src={ic_swap}
                    title={getMessage("TOOLTIP_SWAP_SCREEN")}
                    className="iconSwap"
                    onClick={() => { this.props.setComponentInFocus(COMPONENT_IN_FOCUS.AUDIO_VIDEO) }}
                  />
                }

                {this.props.organiser === this.props.uniqueId &&
                  (
                    <img
                      src={ic_call_cut}
                      className="videoIcon cursorPointer m-0 pr-0 pl-2 d-block"
                      title={getMessage("END_CALL")}
                      onClick={() => {
                        isVideo ?
                          this.onOpenCloseEndVideoCallConfirmationModal(true) :
                          this.onOpenCloseEndAudioCallConfirmationModal(true);
                      }}
                    />
                  )
                }
                { this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO &&
                  <div>
                    <VideoMenu
                      handlePictureInPicture={this.callPictureInPicture}
                      isPictureInPictureEnable={!isMobile && document.pictureInPictureEnabled}
                      handleFullScreen={this.toggleScreenZoomin}
                      isFullScreenEnable={screenfull.isEnabled}
                      handleVideoSettingModalShow={this.handleVideoSettingModalShow}
                    />
                  </div>
                }
              </div>
            </div>
            <div className="col-lg-12 IEflexNone noPadding positionStatic">
              <div className="AudioVideo"
                id="AudioVideo"
              >
                {primaryParticipant && primaryParticipant.mediaType !== "NONE" &&  
                !(typeof(primaryParticipant.mediaType) === "object" && 
                !(primaryParticipant.mediaType.audio || primaryParticipant.mediaType.video)) &&
                  <VideoComponent
                    index={0}
                    sendWebsocketMessage={this.props.sendWebsocketMessage}
                    uniqueId={this.props.uniqueId}
                    participant={primaryParticipant}
                    participants={this.props.sortedParticipants}
                    sessionKey={this.props.sessionKey}
                    key={primaryParticipant.uniqueId + "video"}
                    totalWebRtcElement={this.getTotalWebrtcElement()}
                    deviceList={this.state.deviceList}
                    webRtcPermissionRequest={
                      this.props.webRtcPermissionRequest
                    }
                    isTransform={this.state.isTransform}
                    isVideo={isVideo}
                    snapshoteeId={this.props.snapshoteeId}
                    organiser={this.props.organiser}
                    onOpenCloseEndVideoCallConfirmationModal={this.onOpenCloseEndVideoCallConfirmationModal}
                    onOpenCloseEndAudioCallConfirmationModal={this.onOpenCloseEndAudioCallConfirmationModal}
                    isLandscape={this.props.isLandscape}
                    currentStream={this.currentStream}
                    snapshotPermissionReply={this.props.snapshotPermissionReply}
                    turnServer={this.props.turnServer}
                    showSpinner={this.showSpinner}
                    hideSpinner={this.hideSpinner}
                    enableCamera={this.setEnableCameraFlag}
                    facingMode={this.state.facingMode}
                    selectedDevice={this.state.selectedDevice}
                    setCurrentStream={this.setCurrentStream}
                    setCurrentAudioStream={this.setCurrentAudioStream}
                    headerAction={this.props.headerAction}
                    setFlimStripOverflow={this.setFlimStripOverflow}
                    componentInFocus={this.props.componentInFocus}
                    setScreenShareTopMargin={this.props.setScreenShareTopMargin}
                    videoBandwidthSettings={this.props.videoBandwidthSettings}
                    audioVideoAction={audioVideoAction}
                    isMainScreen={true}
                    isFullScreen={this.state.isFullScreen}
                    toggleScreenZoomout={this.toggleScreenZoomout}
                    audioDeviceId={this.props.audioDeviceId}
                    videoDeviceId={this.props.videoDeviceId}
                    // showFilmStrip={this.showFilmStrip}
                    isFlimStripContainer={false}
                    language={this.props.language}
                    horizontalDisplayFixed={this.props.horizontalDisplayFixed}
                    isFullScreenV2={this.props.isFullScreenV2}
                    inFullScreenV2Container={false}
                    putPeerError={this.putPeerError}
                    isPeerError={this.isPeerError}
                    clearPeerError={this.clearPeerError}
                    isVirtualBackground={this.props.isVirtualBackground}
                    getCurrentVirtualBackgroundFilter={this.getCurrentVirtualBackgroundFilter}
                    selectedBackground={this.props.selectedBackground}
                    recoverCameraStream={this.recoverCameraStream}
                  />
                }

                {this.props.sortedParticipants.length > 1 &&
                <React.Fragment>
                  <div 
                    className={
                      this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO 
                        ? OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO != "true" ?
                          "flimStripContainer alignItemsCenter justifyContentFlexCenter show" :
                          "flimStripContainer overlappingFilmStrip alignItemsCenter justifyContentFlexCenter show positionAbsolute"
                        : this.props.sortedParticipants.length > 4
                          ? "flimStripContainer alignItemsCenter justifyContentFlexCenter show scrollableFilmStrip"
                          : "flimStripContainer alignItemsCenter justifyContentFlexCenter show"
                    } 
                    id="flimStripContainer"
                    role="tabpanel"
                    aria-labelledby="headingOne"
                  >
                    {/* {this.props.componentInFocus==COMPONENT_IN_FOCUS.AUDIO_VIDEO &&
                    <div>
                      <CardImg
                        src={ic_video_left_arrow}
                        id="arrowLeft"
                        className="arrowLeft cursorPointer"
                        onClick={()=> {
                          let flimStrip = document.getElementById("flimStrip")
                          // isIE ? 
                          flimStrip.scrollBy({
                            left: -(flimStrip.offsetWidth * 0.5),
                            top: 0,
                            behavior: 'smooth',
                          })
                          // :
                          // flimStrip.scrollTo({
                          //   left: -(flimStrip.offsetWidth * 0.5),
                          //   behavior: 'smooth',
                          // });
                        }}
                      />
                    </div> 
                    } */}
                    {<div 
                      className={
                        ((this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO 
                          && this.state.isFilmstripVisible) 
                          || this.props.componentInFocus == COMPONENT_IN_FOCUS.CANVAS
                          || this.props.componentInFocus == COMPONENT_IN_FOCUS.COBROWSE)
                          ? "flimStrip" 
                          : "flimStrip collapse"
                      }
                    
                      id="filmStrip"
                      // style ={this.state.sortedParticipants.length == 2 ? 
                      //   {width: "50%"} : 
                      //   {width: "100%"}}
                      style ={smallVideoPostionRightShow ? 
                        {"flexDirection":"column-reverse"} : 
                        {"flexDirection":"row"}}
                    >
                      {this.props.sortedParticipants.map((participant,index) => {
                        {
                          return participant.uniqueId !== primaryParticipant.uniqueId &&    // primary participant is already displayed
                        //participant.mediaType !== "NONE" &&  
                        //!(typeof(participant.mediaType) === "object" && 
                        //!(participant.mediaType.audio || participant.mediaType.video)) ? (
                        (participant.mediaType == mediaType.AUDIO || participant.mediaType == mediaType.AUDIO_VIDEO) ? (
                              <VideoComponent
                                index={index}
                                sendWebsocketMessage={this.props.sendWebsocketMessage}
                                setPrimaryParticipant={this.setPrimaryParticipant}
                                primaryParticipant={primaryParticipant}
                                uniqueId={this.props.uniqueId}
                                participant={participant}
                                participants={this.props.sortedParticipants}
                                sessionKey={this.props.sessionKey}
                                key={participant.uniqueId + "video"}
                                totalWebRtcElement={this.props.sortedParticipants.length}
                                deviceList={this.state.deviceList}
                                webRtcPermissionRequest={
                                  this.props.webRtcPermissionRequest
                                }
                                isVideo={isVideo}
                                isTransform={this.state.isTransform}
                                snapshoteeId={this.props.snapshoteeId}
                                organiser={this.props.organiser}
                                onOpenCloseEndVideoCallConfirmationModal={this.onOpenCloseEndVideoCallConfirmationModal}
                                onOpenCloseEndAudioCallConfirmationModal={this.onOpenCloseEndAudioCallConfirmationModal}
                                isLandscape={this.props.isLandscape}
                                currentStream={this.currentStream}
                                snapshotPermissionReply={this.props.snapshotPermissionReply}
                                turnServer={this.props.turnServer}
                                showSpinner={this.showSpinner}
                                hideSpinner={this.hideSpinner}
                                enableCamera={this.setEnableCameraFlag}
                                facingMode={this.state.facingMode}
                                selectedDevice={this.state.selectedDevice}
                                setCurrentStream={this.setCurrentStream}
                                setCurrentAudioStream={this.setCurrentAudioStream}
                                headerAction={this.props.headerAction}
                                setFlimStripOverflow={this.setFlimStripOverflow}
                                isFilmstripVisible={this.state.isFilmstripVisible}
                                componentInFocus={this.props.componentInFocus}
                                setScreenShareTopMargin={this.props.setScreenShareTopMargin}
                                videoBandwidthSettings= {this.props.videoBandwidthSettings}
                                audioVideoAction= {audioVideoAction}
                                isMainScreen={false}
                                isFullScreen={this.state.isFullScreen}
                                toggleScreenZoomout={this.toggleScreenZoomout}
                                audioDeviceId={this.props.audioDeviceId}
                                videoDeviceId={this.props.videoDeviceId}
                                // showFilmStrip={this.showFilmStrip}
                                isFlimStripContainer={true}
                                language={this.props.language}
                                isFullScreenV2={this.props.isFullScreenV2}
                                inFullScreenV2Container={false}
                                putPeerError={this.putPeerError}
                                isPeerError={this.isPeerError}
                                clearPeerError={this.clearPeerError}
                                isVirtualBackground={this.props.isVirtualBackground}
                                getCurrentVirtualBackgroundFilter={this.getCurrentVirtualBackgroundFilter}
                                selectedBackground={this.props.selectedBackground}
                                recoverCameraStream={this.recoverCameraStream}
                              />
                            ) : null;
                        }
                      })}
                    </div>}

                    {/* {this.props.componentInFocus==COMPONENT_IN_FOCUS.AUDIO_VIDEO &&
                    <div className="arrowParent">
                      <CardImg
                        src={ic_video_right_arrow}
                        className="arrowRight cursorPointer"
                        onClick={()=> {
                          let flimStrip = document.getElementById("flimStrip");
                          // isIE ? 
                          flimStrip.scrollBy({
                            left: flimStrip.offsetWidth * 0.5,
                            behavior: 'smooth',
                          })
                          // :
                          // flimStrip.scrollTo({
                          //   left: flimStrip.offsetWidth * 0.5,
                          //   behavior: 'smooth',
                          // });
                        }}
                      />
                    </div>
                    } */}
                  </div>
                </React.Fragment> }
                { OVERLAP_FILMSTRIP_ON_REMOTE_VIDEO == "true" 
                && this.props.sortedParticipants
                && this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO
                && this.props.sortedParticipants.length > 1
                && (this.state.isFilmstripVisible || this.state.hasUserClickedFilmStripCaret) &&
                  <div
                    id="filmStripHandler"
                    className={
                      this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO
                        ? "filmStripCaret"
                        : ""
                    }
                  >
                    <div className="caretStyle">
                      <div
                        data-toggle="collapse"
                        href="#filmStrip"
                        aria-expanded="true"
                        aria-controls="filmStrip"
                        onClick={this.setUserHasClickedFilmStripCaret}
                      />
                    </div>
                  </div>
                } 
              </div>
            </div>
          </Card>
        </div>
        {
          this.state.showEndAudioCallConfirmationModal &&

          <EndAudioVideoCallConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={() => { this.onOpenCloseEndAudioCallConfirmationModal(false) }}
            handleYesClick={() => {
              this.onOpenCloseEndAudioCallConfirmationModal(false);
              this.onClose();
            }}
            message={getMessage("END_AUDIO_CALL_CONFIRMATION_TEXT")}
          />
        }
        {
          this.state.showEndVideoCallConfirmationModal &&

          <EndAudioVideoCallConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={() => { this.onOpenCloseEndVideoCallConfirmationModal(false) }}
            handleYesClick={() => {
              this.onOpenCloseEndVideoCallConfirmationModal(false);
              this.onClose();
            }}
            message={getMessage("END_VIDEO_CALL_CONFIRMATION_TEXT")}
          />
        }
      </React.Fragment>
    );
  }

  componentWillUnmount() {
    if(this.isFullScreenV2Target()) {
      this.props.removeFullScreenV2Target(this);
    }
    this.virtualBackgroundFilter && this.virtualBackgroundFilter.destroy();
    this.stopTracks(this.currentStream);
    this.stopAudioTracks(this.currentAudioStream);
    if (!this.props.inFullScreenV2Container) {
      if(this.needRemoveFullScreenChangeHandler) {
        screenfull.off('change', this.fullScreenChangeHandler );
      }
    }
    // remove scroll listener
    window.removeEventListener('scroll', this.setIconPosition);
  }
}

const mapStateToProps = state => ({
  participantId: selectParticipantId(state),
  uniqueId: selectCurrentParticipantUniqueId(state),
  userRole: selectUserRole(state),
  admittedParticipants: getAdmittedParticipants(state),
  sessionKey: selectSessionKey(state),
  token: selectUserToken(state),
  organiser: selectOrganiser(state),
  webRtcPermissionReply:state.SessionReducer.webRtcPermissionReply,
  snapshoteeId:selectSnapshoteeId(state),
  showSnapshot: selectShowSnapshot(state),
  stopVideoCall:getStopVideoCallFlag(state),
  startVideoCall:getStartVideoCallFlag(state),
  snapshotPermissionReply:selectSnapshotPermissionReply(state),
  turnServer:selectTurnServerData(state),
  sortedParticipants:getSortedParticipants(state),
  videoBandwidthSettings: getVideoBandwidthSettings(state),
  showCustomerCoBrowse: getShowCustomerCoBrowse(state),
  // fullScreen:getFullScreen(state)
  isRecording: getIsRecording(state),
  audioRecordingMessage: getAudioRecordingMessage(state),
  videoRecordingMessage: getVideoRecordingMessage(state),
  recordingTarget: getRecordingTarget(state),
  recordingMethod: getRecordingMethod(state),
  isVideoTransform: getIsVideoTransform(state),
  previewAudio: getPreviewAudio(state),
  audioDeviceId: getAudioDeviceId(state),
  videoDeviceId: getVideoDeviceId(state),
  facingMode: getFacingMode(state),
  isVirtualBackground: getIsVirtualBackground(state),
  selectedBackground: getSelectedBackground(state),
  showAudioSettingModal: getShowAudioSettingModal(state),
  subModulesAudioVideo: selectSubModulesAudioVideo(state),
  deactiveModules: selectDeactiveModules(state),
  language: state.LanguageReducer.language,
  isFullScreenV2: getIsFullScreenV2(state),
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      sendWebsocketMessage: sendWebsocketMessage
    },
    dispatch
  );
};
export default withOrientationChange(connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioVideoContainer));
